import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { LAUNCH_WITH_FAIRE_ENABLED_FOR_RETAILER_COUNTRY } from "@faire/web-api--source/indigofair/settings/LAUNCH_WITH_FAIRE_ENABLED_FOR_RETAILER_COUNTRY";
export var getSettingOpenWithFaireAvailableForCountry = function() {
    return getSettingValueWithoutAssignment(LAUNCH_WITH_FAIRE_ENABLED_FOR_RETAILER_COUNTRY, false);
};
